module.exports = __webpack_public_path__ + "img/jiabin2.370da40e.png";